module.exports = __webpack_public_path__ + "img/glogo209.15aaa0db.png";